export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        actionsDBNO: [],
        formActionsDBNO: [],
        rowActionsDBNO: [],
        headerFieldsDBNO: [
            {
                name: "id",
                label: "ID",
                sort: true,
                visibility: false
            },
            {
                name: "code",
                label: "BNO kód",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true
            },
            {
                name: "description",
                label: "Leírás",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false
            },
            {
                name: "companyId",
                label: "companyId",
                visibility: false
            }
        ]
    }
}
